import * as React from 'react';
import { Hero } from '@brightlayer-ui/react-components/core';
import { getIcon } from '../../lib/icons';
import { ChannelDatum } from '../../types';
import { getMetric } from '../../data/domain/metric-data-helpers';

export const MetricHero: React.FC<{
    channelDatum: ChannelDatum;
    testId?: string;
    /**
     * When true, the hero stretches to fill an equal share of the parent flex
     * container (used when ≤4 tiles share a single row so they look balanced).
     * When false/undefined, the hero takes a fixed 80px slot (used when 5+ tiles
     * need to scroll horizontally inside a narrow card).
     */
    fillEvenly?: boolean;
}> = (props) => {
    const metric = getMetric(props.channelDatum);
    const TheIcon = getIcon(metric.icon, 'Clear');

    const wrapperStyle: React.CSSProperties = props.fillEvenly
        ? { flex: '1 1 0', minWidth: 0, width: 'auto' }
        : { flex: '0 0 80px', width: 80 };

    return (
        <div style={wrapperStyle} title={metric.channelName}>
            <Hero
                data-testid={props.testId}
                icon={
                    <TheIcon
                        fontSize="large"
                        style={metric.iconColor ? { color: metric.iconColor } : {}}
                        data-testid={`${metric.icon}-icon`}
                    />
                }
                label={metric.channelName}
                ChannelValueProps={{
                    value: metric.value ? metric.value : "",
                    units: metric.units,
                    style: { fontSize: 'initial' },
                }}
                iconSize="small"
                sx={{
                    '& .BluiHero-label': {
                        whiteSpace: 'normal !important',
                        overflow: 'visible !important',
                        textOverflow: 'clip !important',
                        wordBreak: 'break-word',
                        lineHeight: 1.15,
                        fontSize: '0.875rem',
                    },
                }}
            />
        </div>
    );
};
